import { render, staticRenderFns } from "./ServiceTasksForm.vue?vue&type=template&id=cfc24902&"
import script from "./ServiceTasksForm.vue?vue&type=script&lang=ts&"
export * from "./ServiceTasksForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports